import { SwapPrice } from '@/core/swap';
import Icon, { Icons } from '@/presentation/components/elements/Icon';
import ellipsis from '@/presentation/utils/ellipsis';
import { Transaction } from 'nftx.js';
import { useTranslations } from 'use-intl';
import { TransactionReceipt } from 'viem';
import { Chain } from 'wagmi';

const SwapError = ({
  receipt,
  transaction,
  error,
  type = 'erc20',
  buySymbol,
  sellSymbol,
  chain,
  onRetryClick,
  onEditClick,
}: {
  receipt?: TransactionReceipt<any>;
  transaction?: Transaction;
  error: any;
  type?: SwapPrice['type'];
  buySymbol?: string;
  sellSymbol?: string;
  chain: Chain;
  onRetryClick: () => void;
  onEditClick: () => void;
}) => {
  const t = useTranslations('Swap');

  return (
    <div className="p-6 bg-gray-50 max-w-lg mx-auto">
      <h2 className="text-lg text-center mb-2 font-bold">
        {t(`Processing.${type}.title`, { buySymbol, sellSymbol })}
      </h2>
      <div className="p-4 flex justify-center items-center">
        <Icon name={Icons.X_MARK} size={48} className="text-red-500" />
      </div>
      <p className="text-center mb-4">
        <a
          href={`${chain.blockExplorers?.default.url}/tx/${transaction?.hash}`}
          className="inline-flex items-center"
        >
          {t('Processing.tx', { hash: ellipsis(transaction?.hash) })}
          <Icon name={Icons.EXTERNAL} size={12} className="ml-1" />
        </a>
      </p>
      <aside className="mb-4">
        <div className="bg-red-500 p-4 rounded flex gap-4 break-all">
          <span>
            <Icon name={Icons.EXCLAMATION_TRIANGLE} className="text-white" />
          </span>
          <span className="text-sm text-white">{JSON.stringify(error)}</span>
        </div>
      </aside>
      <section className="rounded-md bg-gray-100 border border-gray-300 divide-y divide-gray-300">
        <h3 className="p-4 text-center font-medium">{t('Error.help')}</h3>
        <ul className="divide-y divide-gray-300">
          <li className="p-4 flex justify-between">
            <div>
              <h4>{t('Error.increaseGas')}</h4>
            </div>
            <button
              type="button"
              onClick={onRetryClick}
              className="underline hover:no-underline font-bold"
            >
              {t('Error.retry')}
            </button>
          </li>
          <li className="p-4 flex justify-between">
            <div>
              <h4>{t('Error.changeItems')}</h4>
            </div>
            <button
              type="button"
              onClick={onEditClick}
              className="underline hover:no-underline font-bold"
            >
              {t('Error.edit')}
            </button>
          </li>
        </ul>
      </section>
    </div>
  );
};

export default SwapError;
